export default __webpack_public_path__ + "static/tag-do-5-dark-5a4289080252538831a17bb9d1b8f76db58fe930f907026faf1144867365647b.png";